import selectOption from './select-option.vue'

selectOption.install = function(Vue) {
  Vue.component(selectOption.name, selectOption)
}

export default selectOption
